import { StyleProp, View, ViewStyle } from 'react-native';
import { ClickableLetterSquare } from './index';
import { useState } from 'react';
import { useResponsiveHeight } from '@/hooks/useResponsiveDimensions';
import { styles } from './styles';

type SplitLetter = {
  key: string | number;
  i: number;
  letter: string;
  capitalLetter: string;
  order: number | number[];
};

type ClickableLetterSquareContainerProps = {
  isCapitallizeAll: boolean;
  splitLetters: SplitLetter[];
  onWrong: (onWrongParam: number) => void;
  onCorrect: (id: number, currentOrder: number, letter: string) => void;
  currentOrder: number;
  guessedLetters: number[];
  wrongBoxChosen: number;
};

export function ClickableLetterSquareContainer({
  isCapitallizeAll,
  splitLetters,
  onWrong,
  onCorrect,
  currentOrder,
  guessedLetters,
  wrongBoxChosen,
}: ClickableLetterSquareContainerProps) {
  let size = 0,
    marginLeft = 0;

  const [dimensions, setDimensions] = useState({ width: 1, height: 1 });

  const onLayout = (event: {
    nativeEvent: { layout: { width: number; height: number } };
  }) => {
    const { width, height } = event.nativeEvent.layout;
    setDimensions({ width, height });
  };

  let containerHeight = dimensions.height;
  let maxSize = Math.min(containerHeight, 180);
  let fullWidth = dimensions.width;
  let totalMaxSize = useResponsiveHeight(12.07);

  function calculateLetterSizes(fitsInOneLine: boolean) {
    let tempMaxSize: number;
    if (fitsInOneLine) {
      tempMaxSize = maxSize * 0.7;
    } else {
      tempMaxSize = maxSize / 2;
    }
    size = fullWidth / (splitLetters.length / 2);
    marginLeft = fullWidth / 400;
    size = size - marginLeft * 2.5;
    size = Math.min(tempMaxSize, size);

    // this limits the total size of the buttons to be simmilar to the maximum of the 'solved' buttons on top.
    // remove this line for mobile support to have maximum sized buttons.
    size = Math.min(totalMaxSize, size);
  }
  calculateLetterSizes(true);

  let fitsInOneLine = (size + marginLeft) * splitLetters.length <= fullWidth;

  if (!fitsInOneLine) {
    calculateLetterSizes(false);
  }

  fitsInOneLine = (size + marginLeft) * splitLetters.length <= fullWidth;
  let leftSpaceVertical = 0;
  let leftSpaceHorizontal = 0;
  if (fitsInOneLine) {
    leftSpaceHorizontal = fullWidth - (size + marginLeft) * splitLetters.length;
    leftSpaceVertical = containerHeight - size;
  }

  // TODO: finish logic to add random margin between letters if its possible
  let randomMarginStyles: StyleProp<ViewStyle>[] = [];
  for (let i = 0; i <= splitLetters.length; i++) {
    let randomMarginStyle: object = {};
    if (fitsInOneLine) {
      randomMarginStyle = {
        paddingTop:
          i % 2 ? -1 * (leftSpaceVertical / 5) : leftSpaceVertical / 3,
        paddingBottom:
          i % 2 ? leftSpaceVertical / 5 : (-1 * leftSpaceVertical) / 3,
        paddingLeft: leftSpaceHorizontal / (splitLetters.length * 2 + 4),
        paddingRight: leftSpaceHorizontal / (splitLetters.length * 2 + 4),
      };
    }
    randomMarginStyles.push(randomMarginStyle);
  }

  return (
    <View style={styles.letterContainer} onLayout={onLayout}>
      {splitLetters.map((eachIter, index) => {
        const { key, i, letter, capitalLetter, order } = eachIter;
        return (
          <View key={index} style={randomMarginStyles[index]}>
            <ClickableLetterSquare
              key={key}
              id={i}
              isHidden={guessedLetters.includes(i)}
              currentOrder={currentOrder}
              order={order}
              letter={isCapitallizeAll ? capitalLetter : letter}
              onCorrect={onCorrect}
              onWrongParam={index}
              onWrong={onWrong}
              size={size}
              marginLeft={marginLeft}
              wrongBoxChosen={wrongBoxChosen}
            />
          </View>
        );
      })}
    </View>
  );
}
